import React from 'react';
import {faEdit,faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import { Button, Typography } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const Listcomponent = (props) => {
  return(
    <>
        {props.list.map((li, i) => (
            <li key={i}>
                {li.value}
                <Typography component={"span"}>
                    <Button size="small" onClick={() => props.handlelistEdit(li.id)} >
                    {" "}
                    <FontAwesomeIcon icon={faEdit} style={{ fontSize: "15px", color: "green" }} />{" "}
                    </Button>{" "}
                </Typography>
                <Typography component={"span"}>
                <Button size="small" onClick={() => props.handlelistDelete(li.id)} >
                    <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "15px", color: "red" }} />
                </Button>
                </Typography>
                </li>
            ))}
</>
);
};
export default Listcomponent;